/**
 * Admin V3 — Booking Detail navigation authority (AV3-M2)
 *
 * SINGLE SOURCE for Booking Detail navigation. Booking is the only V3 capability
 * that historically deep-linked into the legacy V2 page (governance audit: 9
 * call sites, 1 destination). This helper resolves which admin surface owns
 * Booking Detail navigation, gated by a build-time flag.
 *
 * DARK-LAUNCH (default OFF). Merging AV3-M2 must NOT auto-activate the cutover
 * in production; activation requires a separate explicit production
 * configuration decision (set the flag to "true" at build time).
 *
 * Authority resolution:
 *   - `VITE_ADMIN_V3_BOOKING_DETAIL` === "true"   → V3-native page
 *       /admin-v3/bookings/:id   (AV3-M1)
 *   - unset / any other value (incl. "false")     → legacy V2 page  (DEFAULT)
 *       /admin/bookings/:id
 *
 * Rollback / activation is a frontend-only flag flip + rebuild; the V2 route
 * stays mounted regardless. ACTIVATED under AV3 A-3 (flag = "true" in the
 * production build).
 *
 * SCOPE: booking-specific by design. The Runtime Navigation Authority Framework
 * was REJECTED by the governance study — do NOT generalise this into a generic
 * navigation resolver.
 *
 * NOTE: RefundGuidanceModal now ALSO routes through this helper (AV3 A-3). Its
 * former V2-only refund escape is obsolete since refund execution is V3-native
 * (AV3 A-2); the affordance follows the same cutover authority (V3 when active,
 * legacy V2 on rollback).
 *
 * Env is read at call-time (not module load) so build-time overrides and tests
 * resolve deterministically.
 */
export const bookingDetailPath = (bookingId) => `/admin/bookings/${bookingId}`;

export default bookingDetailPath;
